export default class DtoFunction {
    constructor(obj) {
        this.idStation = obj.idStation
        this.startDate = obj.startDate
        this.endDate = obj.endDate
        this.functionCode = obj.functionCode
        this.description = obj.description
    }
}